// extracted by mini-css-extract-plugin
export default {"Body":"_Body--aqpA8","BodyContainer":"_BodyContainer--ZGFqV","BodyText":"_BodyText--tNL5C","WarningIcon":"_WarningIcon--You_e","ContinueButton":"_ContinueButton--gfBcy"};